<div class="row">
  <div class="content-wrap col-xs-12 col-sm-7 col-sm-offset-3">
    <h1>{{ welcomeMsg }}<br />{{ 'reservationInfoTemplate.thankYou' | translate }}</h1>
    <br />
    <div class="row">
      <div class="col-md-8">
        <div class="element-wrapper">
          <div class="element-box">
            <h6 class="element-header">{{ 'reservationInfoTemplate.overviewTitle' | translate }}</h6>
            <div>
              <div class="info-block" style="flex: 1 1 1e-09px; box-sizing: border-box;">
                <div>
                  <div class="row">
                    <div class="property">
                      <span>{{ 'reservationInfoTemplate.reservedFor' | translate }}</span>
                    </div>
                    <div class="definition" *ngIf="reservation">
                      {{ reservation.reservedFor | dfnsFormat: 'dddd, DD. MMM YYYY' }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="property">
                      <span>{{ 'reservationInfoTemplate.time' | translate }}</span>
                    </div>
                    <div class="definition" *ngIf="reservation">
                      {{ reservation.reservedFor | dfnsFormat: 'HH:mm' }} Uhr
                    </div>
                  </div>

                  <div class="row">
                    <div class="property">
                      <span>{{ 'reservationInfoTemplate.guestCount' | translate }}</span>
                    </div>
                    <div class="definition">{{ reservation?.peopleCount }} Personen</div>
                  </div>

                  <div class="row">
                    <div class="property">
                      <span>{{ 'reservationInfoTemplate.yourMessage' | translate }}</span>
                    </div>
                    <div class="definition">
                      {{ reservation?.msg ? reservation.msg : '-' }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="property">
                      <span>{{ 'reservationInfoTemplate.status' | translate }}</span>
                    </div>
                    <div class="definition" *ngIf="reservation">
                      <span *ngIf="reservation.status === 'confirmed'" class="text-success">
                        <i class="fas fa-check-circle"></i>
                        {{ 'widget.reservation.confirmed' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'arrived'" class="text-secondary">
                        <i class="fas fa-store-alt fa-fw"></i>
                        {{ 'widget.reservation.arrived' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'placed'" class="text-info">
                        <i class="fas fa-chair fa-fw"></i>
                        {{ 'widget.reservation.placed' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'finished'" class="text-success">
                        <i class="fas fa-check-double fa-fw"></i>
                        {{ 'widget.reservation.finished' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'pending'" class="text-warning">
                        <i class="fas fa-minus-circle fa-fw"></i>
                        {{ 'widget.reservation.pending' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'canceled'" class="text-danger">
                        <i class="fas fa-ban fa-fw"></i>

                        {{ 'widget.reservation.canceled' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'noShow'" class="text-danger">
                        <i class="fas fa-eye-slash fa-fw"></i>
                        {{ 'widget.reservation.noShow' | translate }}
                      </span>
                      <span *ngIf="reservation.status === 'waiting'" class="text-muted">
                        <i class="fas fa-hourglass-half fa-fw"></i>
                        {{ 'widget.reservation.waiting' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row"
                style="color:red; margin-top:20px;"
                *ngIf="
                  reservation &&
                    ((reservation.payments && reservation.payments.status == 'finished') || reservation.ticketOrderId);
                  else other_content
                "
              >
                {{ 'reservationInfoTemplate.depositNotice' | translate }}
              </div>

              <ng-template #other_content>
                <div class="row" style="margin-top:20px;">
                  <button
                    class="btn btn-danger btn-block"
                    (click)="cancelReservation()"
                    *ngIf="reservation && reservation.status !== 'canceled'"
                  >
                    {{ 'reservationInfoTemplate.cancelRes' | translate }}
                  </button>
                </div>
              </ng-template>
            </div>
          </div>
          <div *ngIf="reservation && reservation.status !== 'canceled' && creditCardGuarantee">
            <div class="element-wrapper">
              <div class="element-box">
                <h6 class="element-header">{{ 'ResSettings.ResAddPaymentTemplate.CancellationPolicy' | translate }}</h6>
                <p [innerHTML]="cancellationText"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="element-wrapper">
          <div class="element-box">
            <h6 class="element-header">{{ 'reservationInfoTemplate.contact' | translate }}</h6>
            <div>
              <img
                src="//cdn.gastroguide.de/{{ reservation?.client.logo }}"
                *ngIf="reservation && reservation.client.logo"
                class="client-logo"
              />
              <br />
              <strong>{{ reservation?.client.name }}</strong
              ><br />
              <span>{{ reservation?.client.street }}</span
              ><br />
              <span>{{ reservation?.client.zipCode }} {{ reservation?.client?.locationData?.name || '' }}</span>
              <br /><br />
              <span><i class="fas fa-phone fa-fw"></i> {{ reservation?.client.telefon }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="footer-info">
      {{ 'reservationInfoTemplate.footer' | translate: { venue: reservation?.client?.name || '' } }}
    </p>
  </div>
</div>
